module.exports = __webpack_public_path__ + "static/media/listicon.a965dd4c.ico";